import React from "react";
import { useNavigate } from "react-router-dom";

const DashboardHome = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const openNavigationMenu = () => {
    const navMenuButton =
      document.querySelector('button[aria-label="Open menu"]') ||
      document.querySelector(".navbar-context-menu button") ||
      document.querySelector(".Disclosure button");

    if (navMenuButton) {
      navMenuButton.click();
    }
  };

  const navItems = [
    {
      name: "Topics",
      path: "/topics",
      icon: (
        <svg
          className="w-6 h-6 text-blue-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      ),
      hint: "Browse all available topics and resources",
      color: "blue",
    },
    {
      name: "Sessions",
      path: "/sessions",
      icon: (
        <svg
          className="w-6 h-6 text-green-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      ),
      hint: "Detailed history of past interactions",
      color: "green",
    },
    {
      name: "OnDemand",
      path: "/ondemand",
      icon: (
        <svg
          className="w-6 h-6 text-purple-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      ),
      hint: "On-demand validation of AI capabilities",
      color: "purple",
    },
  ];

  return (
    <div className="h-[calc(100vh-4rem)] overflow-y-auto">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row gap-4 md:gap-6">
          {navItems.map((item) => (
            <div
              key={item.name}
              onClick={() => handleNavigation(item.path)}
              className={`relative flex-1 rounded-md overflow-hidden transition-all duration-300 group cursor-pointer bg-gray-800 hover:bg-gray-700`}
              title={item.hint}
            >
              <div className="p-5">
                <div className="flex items-center justify-center mb-4">
                  <div className="rounded-full p-3">{item.icon}</div>
                </div>
                <h2 className="text-md font-medium text-center text-white mb-2">
                  {item.name}
                </h2>
                <p className="text-xs text-gray-300 text-center">{item.hint}</p>
              </div>
              <div
                className={`absolute bottom-0 left-0 w-full h-0.5 bg-${item.color}-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left`}
              />
            </div>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <button
            onClick={openNavigationMenu}
            className="inline-flex items-center text-xs text-gray-400 hover:text-white transition-colors duration-200 group focus:outline-none"
            title="Open navigation menu"
          >
            <svg
              className="w-4 h-4 mr-2 group-hover:text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 15l7-7 7 7"
              ></path>
            </svg>
            <span className="group-hover:underline">
              More options available in navigation menu
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;
